export default "__VITE_ASSET__c18a8e69__"